
import { useContext } from 'react';
import { ScheduledTaskDef, findScheduledTaskDefByAgent } from '../../apis/mgmt/api';
import { useReadOnly } from '../common/DataView';
import { useApiFilteredPaginatedList } from '../common/FilteredPaginatedList';
import { ListProps, SectionListLayout, useStatefulList } from '../common/List';
import { useStatefulPaging } from '../common/Paging';
import { ScheduledTaskDefCard } from './ScheduledTaskDefCard';
import { Auth, Role } from '../../apis/Auth';

export const useScheduledTaskDefListByAgent = function (props: {
    agentId: string | undefined,
}) {
    return useApiFilteredPaginatedList<string, ScheduledTaskDef>({
        filterProps: useReadOnly(props.agentId),
        listProps: useStatefulList<ScheduledTaskDef>(),
        pagingProps: useStatefulPaging(),
        filterToQueryParams: (agentId: string) => ({ agentId, size: 1000 }),
        apiQueryFunc: findScheduledTaskDefByAgent
    });
};

export function ScheduledTaskDefSectionList(props: {
    listProps: ListProps<ScheduledTaskDef>
}) {

    const { onAddItem, onEditItem, data } = props.listProps;
    const { is } = useContext(Auth);
    
    return (
        <SectionListLayout title="Programación de tareas" onCreateClick={is(Role.TECHNICIAN) && onAddItem || undefined} >
            {data && data.map((itemData: ScheduledTaskDef, index: number) => (
                <ScheduledTaskDefCard
                    key={itemData.id} 
                    data={itemData}
                    setData={(data) => props.listProps.setItemOrDeleteOld(data, itemData)}
                    onClick={onEditItem}
                    
                />
            ))}
        </SectionListLayout>
    );

}